import { render, staticRenderFns } from "./incl-campaign-product-row.vue?vue&type=template&id=3e654416&scoped=true&lang=html"
import script from "./incl-campaign-product-row.vue?vue&type=script&lang=js"
export * from "./incl-campaign-product-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e654416",
  null
  
)

export default component.exports